import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-creator-web';
import { LocationSpan } from '@mrkt/features/Platform';
import { SnackbarQueue } from '@mrkt/features/snackbar';
import { Page } from '../../../features/page';
import { PageId, PageEvents } from '../../../features/PlatformEvents';
import { ActionPanelPortalRef } from '../../../features/ActionPanel';
import { SidePanel } from '../../../features/SidePanel';
import { LazyBanner } from '../../../features/Banner';
import { Terms } from '../../../features/Terms';
import { PageRouteHeader } from './Header';
import { PageRouteBody } from './Body';
import { SkipLink } from './SkipLink';
import { HelpButton } from '../../../features/HelpWidget';
import { AnalyticsMigrationOnboarding } from '../../../features/AnalyticsMigrationOnboarding';

type RouteComponent = React.ComponentType<RouteComponentProps<any>>;

export type PageRouteProps = {
  path: string;
  pageId?: PageId;
  exact?: boolean;
  header?: RouteComponent;
  body: RouteComponent;
  footer?: RouteComponent;
  showHelp?: boolean;
};

export function PageRoute({
  exact = false,
  path = '/',
  pageId,
  header: Header,
  footer: Footer,
  body: Body,
  showHelp = true,
}: PageRouteProps) {
  return (
    <Route
      exact={exact}
      path={path}
      render={routerProps => (
        <div data-pageid={pageId}>
          <SkipLink />
          <KeyboardDetectionProvider>
            <Page
              actionpanel={<ActionPanelPortalRef />}
              header={
                Header && (
                  <PageRouteHeader>
                    <SidePanel />
                    <Header {...routerProps} />
                  </PageRouteHeader>
                )
              }
              footer={Footer && <Footer {...routerProps} />}
              help={showHelp && <HelpButton />}
            >
              <Terms>
                <>
                  <LazyBanner />
                  <AnalyticsMigrationOnboarding />
                  <PageRouteBody>
                    <Body {...routerProps} />
                  </PageRouteBody>
                  <SnackbarQueue />
                </>
              </Terms>
            </Page>
          </KeyboardDetectionProvider>

          <PageEvents pageId={pageId} />
          <LocationSpan />
        </div>
      )}
    />
  );
}
